import { Theme, useTheme } from '@material-ui/core/styles';
import {
  BarController,
  BarElement,
  CategoryScale,
  ChartData,
  Chart as ChartJS,
  ChartOptions,
  LinearScale
} from 'chart.js';
import React from 'react';
import { Chart } from 'react-chartjs-2';

ChartJS.register(BarController, CategoryScale, LinearScale, BarElement);

export type HistogramNode = {
  range: string;
  value: number;
  min: number;
  max: number;
};

interface HistogramProps {
  nodes: HistogramNode[];
  highlight: readonly number[];
  disabled?: boolean;
}

const Histogram: React.VFC<HistogramProps> = ({
  nodes,
  highlight,
  disabled
}) => {
  const theme = useTheme<Theme>();

  const backgroundColor = nodes.map((_, i) => {
    if (disabled) {
      return theme.palette.background.paper;
    }

    return i >= highlight[0] && i < highlight[1]
      ? theme.palette.primary.light
      : theme.palette.background.paper;
  });

  /* @see https://www.chartjs.org/docs/latest/general/data-structures.html */
  const barData: ChartData = {
    labels: nodes.map((node) => node.range),
    datasets: [
      {
        categoryPercentage: 1,
        backgroundColor,
        hoverBackgroundColor: backgroundColor,
        data: nodes.map((node) => node.value)
      }
    ]
  };

  /* @see https://www.chartjs.org/docs/latest/general/options.html */
  const options: ChartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: { display: false, drawBorder: false },
        ticks: { maxRotation: 0, display: false }
      },
      y: { display: false }
    }
  };

  return (
    <div>
      <Chart
        type="bar"
        data={barData}
        options={options}
        style={{ height: 80 }}
      />
    </div>
  );
};

export default Histogram;
